// Components==============
import Dropdown from 'components/UI/Dropdown/Dropdown';
import React, { useContext, useEffect, useState } from 'react';
import { FilterType, TranslateType } from 'typings';
import { FilterContext } from '../../FilterMenu';
// =========================

export default function SortDropdown({
  initialText,
  id,
}: {
  initialText: TranslateType;
  id: number;
}) {
  const { setFilterValues, triggerReset } = useContext(FilterContext);

  const [selected, setSelected] = useState('');

  const options = [
    'general.terms.all',
    'general.terms.projects',
    'general.terms.courses',
    'project.terms.activities',
    'project.terms.process-steps',
  ];

  useEffect(() => setSelected(''), [triggerReset]);

  useEffect(() => {
    setFilterValues(
      (prev) =>
        prev.map((val) =>
          val.id === id ? { ...val, value: selected } : val
        ) as FilterType[]
    );
  }, [selected]);

  return (
    <Dropdown
      initialText={initialText}
      selectedItem={selected}
      setSelectedItem={setSelected}
      initialOptions={options || []}
      translateOptions
    />
  );
}
